import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import {
  formatInteger,
  formatMiles,
  formatPercent,
} from './geographicSalesIntelligenceUtils'

function KpiCard({ title, value, subtitle }) {
  return (
    <Card body className="card--xs card-with-border geo-kpi-card">
      <p className="geo-kpi-card__label">{title}</p>
      <p className="geo-kpi-card__value">{value}</p>
      {subtitle ? <p className="geo-kpi-card__subtitle">{subtitle}</p> : null}
    </Card>
  )
}

export default function GeographicSalesIntelligenceSummary({ kpis, coverage }) {
  if (!kpis) return null

  const missing = Number(coverage?.ordersWithoutLocation || 0)

  return (
    <div className="geo-sales-summary">
      <Row className="g-3">
        <Col sm={4}>
          <KpiCard
            title="Buyers"
            value={formatInteger(kpis.buyers)}
            subtitle={
              missing > 0
                ? `${formatInteger(missing)} complete orders had no location`
                : 'Complete orders with a purchase location'
            }
          />
        </Col>
        <Col sm={4}>
          <KpiCard
            title="Median Dist."
            value={formatMiles(kpis.medianDistanceMiles)}
            subtitle="Buyer to venue"
          />
        </Col>
        <Col sm={4}>
          <KpiCard
            title="Local Buyers"
            value={formatPercent(kpis.localBuyerPercent)}
            subtitle={`${formatInteger(kpis.localBuyers)} within 50 miles`}
          />
        </Col>
      </Row>
    </div>
  )
}
